import { render, staticRenderFns } from "./JournalCheckersQueueTable.vue?vue&type=template&id=2c64ab90&scoped=true&"
import script from "./JournalCheckersQueueTable.vue?vue&type=script&lang=js&"
export * from "./JournalCheckersQueueTable.vue?vue&type=script&lang=js&"
import style0 from "./JournalCheckersQueueTable.vue?vue&type=style&index=0&id=2c64ab90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c64ab90",
  null
  
)

export default component.exports